import { ArquivoDTO } from '../arquivoDTO';
import { HabilitacaoDTO } from './habilitacaoDTO';

export class FormacaoDTO{

    id!: number;
    nome!: string;
    galeriaBanners!: ArquivoDTO[];
}